var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "campaginsControl" },
    [
      _c(
        "div",
        {
          staticClass: "title",
          class: [_vm.lang, _vm.isLinked ? "linked" : ""],
        },
        [
          _c("span", [
            !_vm.isLinked ? _c("span", [_vm._v("📊 ")]) : _vm._e(),
            _vm._v(_vm._s(_vm.$t("dailyConnectionLimit"))),
          ]),
          _c(
            "a-popover",
            {
              staticStyle: { "z-index": "98" },
              attrs: { trigger: "click" },
              model: {
                value: _vm.step3Visiable,
                callback: function ($$v) {
                  _vm.step3Visiable = $$v
                },
                expression: "step3Visiable",
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "popbox" }, [
                  _c(
                    "p",
                    {
                      staticClass: "main-tit",
                      class: [_vm.lang],
                      style: {
                        "text-align": _vm.lang == "AR" ? "right" : "left",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("step3TipTitle")) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "ptit",
                      class: [_vm.lang],
                      style: {
                        "text-align": _vm.lang == "AR" ? "right" : "left",
                      },
                    },
                    [
                      _c("span", { class: [_vm.lang] }, [
                        _vm._v(_vm._s(_vm.$t("step3TipCon"))),
                      ]),
                      _c(
                        "span",
                        { staticClass: "txt-red", class: [_vm.lang] },
                        [_vm._v(_vm._s(_vm.$t("step3TipCon1")))]
                      ),
                    ]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "main-tit main-tit2",
                      class: [_vm.lang],
                      style: {
                        "text-align": _vm.lang == "AR" ? "right" : "left",
                        "margin-top": "16px",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("step3TipTitle2")) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "ptit",
                      class: [_vm.lang],
                      style: {
                        "text-align": _vm.lang == "AR" ? "right" : "left",
                      },
                    },
                    [
                      _c("span", { class: [_vm.lang] }, [
                        _vm._v(_vm._s(_vm.$t("step3TipCon2"))),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "btn-box",
                      style: {
                        "text-align": _vm.lang == "AR" ? "right" : "left",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "btn-txt",
                          class: [_vm.lang],
                          on: { click: _vm.goStep3Link },
                        },
                        [_vm._v(_vm._s(_vm.$t("bindLinkAccTipBtn")))]
                      ),
                      _c("span", { class: [_vm.lang] }, [
                        _vm._v(_vm._s(_vm.$t("bindLinkAccTipBtnTxt"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c("a-icon", {
                staticStyle: {
                  "font-size": "14px",
                  color: "#0e756a",
                  cursor: "pointer",
                  "margin-left": "6px",
                },
                attrs: { type: "question-circle" },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTipsInfo,
              expression: "showTipsInfo",
            },
          ],
          staticClass: "input-tip",
          class: [_vm.lang],
        },
        [
          _c("span", { staticClass: "input-tip-icon" }, [_vm._v("💡")]),
          _c("span", { staticClass: "input-tip-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("newAccountLimitTip")) + " "),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "limitBox" },
        [
          _c("LimitBox", {
            attrs: { value: _vm.dailyLimit, min: 1, max: 100 },
            on: { change: _vm.handleLimitChange },
          }),
        ],
        1
      ),
      !_vm.isLtd
        ? _c(
            "div",
            {
              staticClass: "title",
              class: [_vm.lang, _vm.isLinked ? "linked" : ""],
            },
            [
              !_vm.isLinked ? _c("span", [_vm._v(" ⭕️ ")]) : _vm._e(),
              _vm._v(_vm._s(_vm.$t("selectAllocationMode")) + " "),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLtd && _vm.showTipsInfo,
              expression: "!isLtd && showTipsInfo",
            },
          ],
          staticClass: "input-tip",
          class: [_vm.lang],
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _c("span", { staticClass: "input-tip-icon" }, [_vm._v("💡")]),
          _c("span", { staticClass: "input-tip-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("allocationModeTip")) + " "),
          ]),
        ]
      ),
      !_vm.isLtd
        ? _c("allocation-options", {
            attrs: {
              allocationMode: _vm.allocationMode,
              "daily-limit": _vm.dailyLimit,
              "active-campaigns-count": _vm.campaignsCount,
            },
            on: { change: _vm.handleAllocationChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }